<template>
  <v-container class="pt-6">
    <v-card class="elevation-12 mb-6">
      <v-card-title class="px-9 pt-7">
        Administrace uživatelů
      </v-card-title>

      <v-card-text class="px-9">
        <v-row>
          <v-col cols="6" class="pt-0">
            <UserSearch v-model="userSearch" @search="searchAction" />
          </v-col>

          <v-col cols="auto" class="ml-auto">
            <v-btn depressed :to="{ name: 'users.add' }" height="40px" color="primary">
              Přidat nového uživatele
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <UserList
          @onChangeOptions="searchAction"
          v-model="dealerList"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import UserSearch from '@/components/UserSearch.vue';
import UserList from '@/components/tables/UserList.vue';
import { notifyDeleteUser } from '@/components/mixins/notifyDeleteUser';

export default {
  name: 'Users',
  components: {
    UserSearch,
    UserList,
  },
  mixins: [notifyDeleteUser],
  data() {
    return {
      userSearch: this.$route.query.search ? this.$route.query.search : '',
      oldUserSearch: '',
      dealerList: {
        list: [],
        options: {
          page: 1,
          itemsPerPage: this.$store.state.settings.tables.userList.itemsPerPage,
          sortBy: ['fullName'],
          sortDesc: [false],
        },
        loading: false,
        serverItemsLength: 0,
      },
    };
  },
  methods: {
    ...mapActions({
      searchDealers: 'users/searchDealers',
    }),
    search() {
      this.loadDealers();
      if (this.$route.query.search !== this.userSearch) {
        this.$router.push({
          name: 'users',
          query: {
            search: this.userSearch,
          },
        });
      }
    },
    loadDealers() {
      this.dealerList.loading = true;
      const searchParams = {
        options: this.dealerList.options,
        searchTerm: this.userSearch,
      };
      this.searchDealers(searchParams).then((response) => {
        this.dealerList.list = response.data.items;
        this.dealerList.serverItemsLength = response.data.totalElements;
      }).finally(() => {
        this.dealerList.loading = false;
        this.oldUserSearch = this.$route.query.search ? this.$route.query.search : '';
      });
    },
    searchAction() {
      if (this.userSearch !== this.oldUserSearch) {
        this.dealerList.options.page = 1;
      }
      this.search();
    },
  },
};
</script>
